import { render, staticRenderFns } from "./addApplication.vue?vue&type=template&id=b0fcb680&scoped=true"
import script from "./addApplication.vue?vue&type=script&lang=ts"
export * from "./addApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fcb680",
  null
  
)

export default component.exports